'use strict';

const _=require('pulsar-utils/dist-es6/_');
const{DataSet,Timeline}=require('vis-timeline');
const Formatters=require('../../../../dist-es6/client/formatters');
const{ScheduleRowDirectiveController}=require('../../../../dist-es6/client/directives/scheduleRowDirective/scheduleRowDirective');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ScheduleRowAxisDirective=class ScheduleRowAxisDirective extends BaseControllerBackedDirective{
get template(){return''}

get objectBindings(){return['axisBounds','freshSearch']}

get $inject(){return['$scope','$timeout','$element','$animate','timeZoneService','scheduleRowScrollingService']}

get controller(){return ScheduleRowAxisController}};






const ENABLE_TIMELINE_SCROLLING=!0;let

ScheduleRowAxisController=class ScheduleRowAxisController extends ScheduleRowDirectiveController{
constructor($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService){
super($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService);

this._scheduleRowScrollingService.setAxis(this);

this._horizontalThrottleSpeedMs=41;
this._animationTimeMs=0;

this._$scope.$evalAsync(()=>this._redraw());
}

_setupWatchers(){
this._$scope.$watch('controller.axisBounds',(newAxisBounds,oldAxisBounds)=>{
if(!this.freshSearch&&_.isEqual(oldAxisBounds,newAxisBounds)){
return;
}
this._visibleBoundsOverride=null;
if(this._timeline){
this._timeline.setOptions({min:newAxisBounds.start,max:newAxisBounds.end});
}

const{defaultWindowSizeInMilliseconds}=this._scheduleRowScrollingService;
const visibleBoundsEnd=newAxisBounds.end.getTime()-newAxisBounds.start.getTime()>defaultWindowSizeInMilliseconds?
new Date(newAxisBounds.start.getTime()+defaultWindowSizeInMilliseconds):
newAxisBounds.end;

this.__updateAxisWindowAndAllScheduleWindows({start:newAxisBounds.start,end:visibleBoundsEnd},0);
this._updateWindow();
this.freshSearch=!1;
});
this._$scope.$on('$destroy',()=>this._scheduleRowScrollingService.setAxis(null));
}

_setupTimeline(){

const zoomable=this._scheduleRowScrollingService.maxWindowSizeInMilliseconds!==this._scheduleRowScrollingService.minWindowSizeInMilliseconds;

this._timeline=new Timeline(this._container[0],this._dataset,_.defaults({
moment:this._momentWithTimeZoneForTimeline,
format:{
minorLabels:(date,scale,step)=>{
return[
Formatters.dayOfWeekInTimeZone(date,this._timeZoneService.localTimeZone).toUpperCase(),
Formatters.monthAndDayInTimeZone(date,this._timeZoneService.localTimeZone,{dayFirst:!0})].
join('<br/>');
}},

showMinorLabels:!0,
onInitialDrawComplete:()=>this._initialDrawComplete=!0,
moveable:ENABLE_TIMELINE_SCROLLING,
zoomable:zoomable,
zoomMax:this._scheduleRowScrollingService.maxWindowSizeInMilliseconds,
zoomMin:this._scheduleRowScrollingService.minWindowSizeInMilliseconds,
min:this.axisBounds.start,
max:this.axisBounds.end,
start:this.currentBounds.start,
end:this.currentBounds.end},
ScheduleRowDirectiveController.DefaultTimelineOptions));






const throttledRangeChanger=_.throttle(newBounds=>this.__updateAxisWindowAndAllScheduleWindows(newBounds,this._animationTimeMs),this._horizontalThrottleSpeedMs);

this._timeline.on('rangechange',obj=>{
if(!obj.byUser){
return;
}

throttledRangeChanger(obj);
});

this._timeline.on('rangechanged',({start,end,byUser})=>{
if(!byUser){
return;
}

this.__updateAxisWindowAndAllScheduleWindows({start,end},0);
});
}

__updateAxisWindowAndAllScheduleWindows({start,end},animationTimeMs){
if(this._visibleBoundsOverride&&
this._visibleBoundsOverride.start.getTime()===start.getTime()&&
this._visibleBoundsOverride.end.getTime()===end.getTime()){
return;
}

this._visibleBoundsOverride={start,end};
this._scheduleRowScrollingService.updateScheduleWindows(animationTimeMs);
}

get currentBounds(){
return this._visibleBoundsOverride||this.axisBounds;
}};


module.exports=ScheduleRowAxisDirective;
module.exports.ScheduleRowAxisDirectiveController=ScheduleRowAxisController;
//# sourceMappingURL=scheduleRowAxisDirective.js.map
